import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { useLanguage } from '../context/LanguageContext';

function Navbar() {
  const { t } = useLanguage();
  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <ul className='nav-menu'>
            <li className="nav-item">
              <Link to="/" className="nav-links">
                {t.navbar_home}
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/itinerario" className="nav-links">
                {t.navbar_itinerary}
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/confirmar" className="nav-links">
                {t.navbar_confirm}
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/regalos" className="nav-links">
                {t.navbar_gifts}
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;